﻿window.info_tp2_algorithm_editpriority = function () {

    var instance = {
        init: function () {
            var _this = this;
            _this.onChangePriority();
            var table = document.querySelector("table[data-tpriority]");
            if (table) {
                table.querySelectorAll("a[data-moverowup]").forEach(function (a) {
                    a.addEventListener("click", function () {
                        _this.moverowup();
                    });
                });

                table.querySelectorAll("a[data-moverowdown]").forEach(function (a) {
                    a.addEventListener("click", function () {
                        _this.moverowdown();
                    });
                });

                _this.setVisibleUpDownButton();
            }
        },

        moverowup: function () {
            var parent = event.currentTarget.parentElement.parentElement;
            var currnum = Number(parent.getAttribute('data-rid')) + 1;
            var tbody = document.querySelector("table[data-tpriority='tpriority']").childNodes[0];
            var firstRow = tbody.rows[currnum - 1];
            var secondRow = tbody.rows[currnum];
            firstRow.parentNode.insertBefore(secondRow, firstRow);
            this.setRowNum();
        },

        moverowdown: function () {
            var parent = event.currentTarget.parentElement.parentElement;
            var currnum = Number(parent.getAttribute('data-rid')) + 1;
            var tbody = document.querySelector("table[data-tpriority='tpriority']").childNodes[0];
            var firstRow = tbody.rows[currnum];
            var secondRow = tbody.rows[Number(currnum) + 2];
            firstRow.parentNode.insertBefore(firstRow, secondRow);
            this.setRowNum();
        },

        setRowNum: function () {
            var i = 0;
            var table = document.querySelector("table[data-tpriority]");
            table.querySelectorAll('tr[data-rid]').forEach(function (tr) {
                tr.setAttribute("data-rid", i++);
            });
            var _this = this;
            _this.setVisibleUpDownButton();
            _this.onChangePriority();
        },

        setVisibleUpDownButton: function () {
            var table = document.querySelector("table[data-tpriority]");
            table.querySelectorAll("a[data-moverowup]").forEach(function (a) {
                a.style.visibility = "visible";
            });
            table.querySelectorAll("a[data-moverowdown]").forEach(function (a) {
                a.style.visibility = "visible";
            });

            table.querySelector("tr:first-child").nextSibling.querySelector("a[data-moverowup]").style.visibility = "hidden";
            table.querySelector("tr:last-child").querySelector("a[data-moverowdown]").style.visibility = "hidden";
        },

        onChangePriority: function () {
            try {
                var table = document.querySelector("table[data-tpriority='tpriority']");
                var dictDescNew = {};
                var rows = table.querySelectorAll("tr[data-rid]");
                rows.forEach(function (tr, index) {
                    var algorithm_ID = tr.querySelector("input[type='hidden'][data-algorithm_id]").value;

                    // Формируем JSON с новыми приоритетами в формате строки ("0", "1", "2", ...)
                    dictDescNew[index] = {
                        stringnumber: String(index), // Новый приоритет в формате строки
                        algorithm_ID: algorithm_ID,
                        priority: String(index) // Новый приоритет в формате строки
                    };
                });

                // Обновляем JSON без изменения видимого приоритета
                document.querySelector("input[name='priorityjson']").value = JSON.stringify(dictDescNew);
            } catch (exc) {
                console.log(exc);
            }
        }
    };
    return instance;
}();